import { render } from "./DiscoverMore2.vue?vue&type=template&id=d05df758&scoped=true"
import script from "./DiscoverMore2.vue?vue&type=script&lang=js"
export * from "./DiscoverMore2.vue?vue&type=script&lang=js"

import "./DiscoverMore2.scss?vue&type=style&index=0&id=d05df758&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d05df758"]])

export default __exports__